module.exports = __webpack_public_path__ + "media/images/plans/arrow-right-a25c3243bb37d2da24ad5510c95e80a3.svg";